import React from 'react';
import { Text, TextMessage } from 'components/tt-forms/common';
import { ShowIf } from 'components/utils';

class LanhDaoGiaoViecKTDXView extends React.Component {

  render() {
    return (
      <div className="items-form mb5">
        <div className="row pl10 pr10 mb10">
          <Text
            className="col-input"
            label="Giao xử lý:"
            value={this.props.thongTinXuLyGiaiQuyet.nextStateInfo ?
              this.props.thongTinXuLyGiaiQuyet.nextStateInfo.tenVietTat : ''} />

          <Text
            className="col-input"
            label="Phòng ban:"
            value={this.props.thongTinXuLyGiaiQuyet.phongBanGiaiQuyetInfo ?
              this.props.thongTinXuLyGiaiQuyet.phongBanGiaiQuyetInfo.ten : ''} />

          <ShowIf condition={this.props.thongTinXuLyGiaiQuyet.nextStateInfo != null && this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo != null && this.props.thongTinXuLyGiaiQuyet.nextStateInfo.type == "LANH_DAO_GIAO_VIEC_TRUONG_PHONG" && this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo.hoVaTen != ''}>
            <Text
              className="col-input"
              label="Trưởng phòng:"
              value={this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo ?
                this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo.hoVaTen : ''} />
          </ShowIf>

          <ShowIf condition={this.props.thongTinXuLyGiaiQuyet.nextStateInfo != null && this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo != null && this.props.thongTinXuLyGiaiQuyet.nextStateInfo.type == "LANH_DAO_GIAO_VIEC_CAN_BO" && this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo.hoVaTen != ''}>
            <Text
              className="col-input"
              label="Công chức giải quyết:"
              value={this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo ?
                this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinhInfo.hoVaTen : ''} />
          </ShowIf>
        </div>

        <div className="row pl10 pr10 mb10">
          <TextMessage
            className="col-12"
            value={this.props.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo.yKienXuLy ? this.props.thongTinXuLyGiaiQuyet.thongTinYeuCauKiemTraDeXuatInfo.yKienXuLy : ''}
            label='Nội dung giao việc:' />
        </div>
      </div>
    )
  }
}

export default LanhDaoGiaoViecKTDXView;


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-kiem-tra-de-xuat/lanh-dao/LanhDaoGiaoViecKTDXView.jsx